import { CloseButton, type CloseButtonProps } from '@chakra-ui/react'
import { SizeType } from '@/types'
import React from 'react'


interface Props extends CloseButtonProps {
  size?: SizeType,
};

const Component = React.forwardRef((props: Props, ref: React.Ref<any>) => {
  return (
    <CloseButton ref={ref} { ...props } />
  )
})


export {
  Component as CloseButton,
  type Props as CloseButtonProps,
}